import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../AppContext";

/**
 * Badge de version PROGÈRE. Affiche la version courante d'un module et
 * pointe vers /nouveautes. Utilisé dans la sidebar, le menu profil et
 * la page Paramètres → À propos.
 */
export default function ProgereVersionBadge({ moduleCode, moduleName, version: versionProp, compact = false }) {
  const [version, setVersion] = useState(versionProp || null);

  useEffect(() => {
    if (versionProp) { setVersion(versionProp); return; }
    let cancelled = false;
    axios.get(`${API}/releases/current`, { params: { module_code: moduleCode } })
      .then(({ data }) => { if (!cancelled) setVersion(data.version); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [moduleCode, versionProp]);

  if (!version) return null;

  if (compact) {
    return (
      <Link
        to="/nouveautes"
        data-testid={`version-badge-${moduleCode}`}
        className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold transition hover:brightness-110"
        style={{
          background: "color-mix(in srgb, var(--pg-gold) 12%, transparent)",
          border: "1px solid color-mix(in srgb, var(--pg-gold) 36%, transparent)",
          color: "var(--pg-gold)",
        }}
      >
        v{version}
      </Link>
    );
  }

  return (
    <Link
      to="/nouveautes"
      data-testid={`version-badge-${moduleCode}`}
      className="block rounded-xl p-3 transition hover:brightness-110"
      style={{
        background: "var(--pg-bg-tertiary)",
        border: "1px solid var(--pg-border)",
      }}
    >
      <div className="text-[10px] font-semibold uppercase tracking-widest" style={{ color: "var(--pg-text-muted)" }}>
        PROGÈRE {moduleName || moduleCode.toUpperCase()}
      </div>
      <div className="mt-1 flex items-center gap-2">
        <span
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded font-black text-[11px]"
          style={{ background: "var(--pg-gold)", color: "var(--pg-text-inverse)" }}
        >
          v{version}
        </span>
        <span className="text-xs" style={{ color: "var(--pg-gold)" }}>Nouveautés →</span>
      </div>
    </Link>
  );
}
